import {FC} from 'react'
import {FilePreview} from 'components/ui/FilePreview'

interface FileNameLinkProps {
  url: string
  children: string
}

export const FileNameLink: FC<FileNameLinkProps> = ({url, children}) => (
  <>
    <a href={url} className="u-txt-link" target="_blank" rel="noopener noreferrer" download>
      {children}
    </a>
    <FilePreview file={{url, filename: children}} />
  </>
)
